import React from 'react'
import { Helmet } from 'react-helmet'
import PageTitle from '../../Components/PageTitle/PageTitle.jsx'

export default function Projects() {
    return (
        <div>
            <Helmet>
                <title>Projects Hossam</title>
            </Helmet>
            <PageTitle title="Project" />
            
        </div>
    )
}
